import { Controller } from "@hotwired/stimulus"

// Docked activity feed panel -- desktop-only width collapse (>= 768px,
// matches Tailwind's `md:` breakpoint). This element collapses to a narrow
// `w-10` sliver via width classList toggling, state persisted in a cookie.
//
// Below `md` the panel is presented as a bottom sheet instead -- see
// bottom_sheet_controller.js, attached to the same element via a second
// `data-controller` entry (see shared/_docked_activity_feed.html.erb). This
// controller no-ops entirely below the breakpoint so the two controllers
// never fight over the same target's inline styles/classes.
export default class extends Controller {
  static targets = ["expandedContent", "collapseIcon", "expandIcon"]
  static values = {
    cookieKey: { type: String, default: "panel_collapsed" },
    expandedClass: { type: String, default: "w-1/5" }
  }

  connect() {
    this.mediaQuery = window.matchMedia("(min-width: 768px)")
    if (!this.isDesktop()) return

    this.collapsed = this.readCookie() === "true"
    this.applyState()
  }

  toggle() {
    if (!this.isDesktop()) return

    this.collapsed = !this.collapsed
    this.applyState()
    this.saveCookie()

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 300)
  }

  isDesktop() {
    return this.mediaQuery.matches
  }

  applyState() {
    const expandedClasses = this.expandedClassValue.split(/\s+/).filter(Boolean)

    if (this.collapsed) {
      this.expandedContentTarget.classList.add("opacity-0", "pointer-events-none")
      this.collapseIconTarget.classList.add("hidden")
      this.expandIconTarget.classList.remove("hidden")
      this.element.classList.remove(...expandedClasses)
      this.element.classList.add("w-10")
    } else {
      this.expandedContentTarget.classList.remove("opacity-0", "pointer-events-none")
      this.collapseIconTarget.classList.remove("hidden")
      this.expandIconTarget.classList.add("hidden")
      this.element.classList.add(...expandedClasses)
      this.element.classList.remove("w-10")
    }
  }

  readCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${this.cookieKeyValue}=([^;]*)`))
    return match ? decodeURIComponent(match[1]) : null
  }

  saveCookie() {
    document.cookie = `${this.cookieKeyValue}=${this.collapsed}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`
  }
}
